/* eslint-disable no-empty-pattern */
import http from '@plugins/axios';

export const actions = {
  template({}) {
    return `${process.env.VUE_APP_API_URL}/langganan/template`;
  },
  async upload({}, payload) {
    const url = `/langganan/upload`;
    return http.post(url, payload.data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
};

export default {
  namespaced: true,
  actions,
};
